import { useLocation, matchPath } from 'react-router-dom';
import { ApplicationLoadError } from 'further-ui/components';
import { useLogout } from 'hooks/ui/useLogout';
import { Box, Button } from '@mui/material';
import useUser from 'hooks/ui/useUser';
import { useWhiteLabellingContext } from 'contexts/WhiteLabellingContext';
import getUserType from 'utils/getUserType';
import { CommonRoutes } from 'routes/index';

const LpGreenSiteGate: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const location = useLocation();
  const user = useUser();
  const { isSubdomain } = useWhiteLabellingContext();
  const { userIsLpInvestor } = getUserType(user);
  const { logout } = useLogout();
  const isAuthenticated = user?.isAuthenticated && !user?.authGateDecision;

  const isVisitingPrivateRoute = CommonRoutes.some(
    ({ path, exact, private: isPrivate }) =>
      !!isPrivate && !!matchPath(location?.pathname, { path, exact }),
  );

  const shouldShowWarning =
    !isSubdomain &&
    isAuthenticated &&
    userIsLpInvestor &&
    isVisitingPrivateRoute;

  return (
    <>
      {shouldShowWarning ? (
        <ApplicationLoadError
          logoPath="assets/images/logo.webp"
          title="Your account isn't available on this site"
          description="You are logged in as an LP investor, however it's not possible to view this account on this site."
          instructionsTitle="To fix this issue:"
          instructions={[
            `Go back to the ${user.firmName ?? 'firm'} specific site.`,
            "If that doesn't work please use the button below to logout",
          ]}
          action={
            <Box
              display="flex"
              gap={4}
              flexDirection="column"
              justifyContent="center"
            >
              <a href={user.firmHomepage}>
                <Button variant="contained" color="primary">
                  Back to {user.firmName}
                </Button>
              </a>
              <span>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={(_e) => logout()}
                >
                  Logout
                </Button>
              </span>
            </Box>
          }
        />
      ) : (
        children
      )}
    </>
  );
};

export default LpGreenSiteGate;
